export default {
  title: 'Suivre la commande',
};
